<template>
  <div class="reservation-list-container" v-loading.fullscreen.lock="display.isLoading">
    <div class="centre">
      <h3>My Reservations</h3>
      <el-button class="bg-gold black" @click="onClickBack">Back</el-button>
    </div>
    <div
      v-if="reservations.length > 0"
      class="section reservation-list"
      v-infinite-scroll="loadNextPage"
      :infinite-scroll-immediate="true"
    >
      <el-card
        class="bg-gold reservation-list__item"
        v-for="reservation in reservations"
        :key="reservation._id"
      >
        <el-row class="reservation-list__item__header" :gutter="10">
          <el-col
            :span="16"
          >{{ reservation.display.createdTime.time }}, {{ reservation.display.createdTime.date }}</el-col>
          <el-col :span="8">
            <div class="centre bg-black gold font-bold">{{ reservation.status }}</div>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="10">
          <el-col :span="12">{{ reservation.customer.phone }}</el-col>
          <el-col :span="12" class="right">
            <div>{{ reservation.display.customer.name }},</div>
            <div>{{ reservation.attributes.numberOfCustomers }} customers</div>
          </el-col>
        </el-row>
        <el-row class="section" :gutter="10">
          <el-col :span="10">
            <strong>Reserved Time</strong>
          </el-col>
          <el-col
            :span="14"
            class="right"
          >{{ reservation.display.reservedTime.time }}, {{ reservation.display.reservedTime.date }}</el-col>
        </el-row>
        <el-row v-if="reservation.arrivedTime" :gutter="10">
          <el-col :span="10">
            <strong>Arrived Time</strong>
          </el-col>
          <el-col
            :span="14"
            class="right"
          >{{ reservation.display.arrivedTime.time }}, {{ reservation.display.arrivedTime.date }}</el-col>
        </el-row>
        <el-row :gutter="10" v-if="reservation.comments">
          <el-col :span="10">
            <strong>Comments</strong>
          </el-col>
          <el-col :span="14" class="right">{{ reservation.comments }}</el-col>
        </el-row>
        <el-row :gutter="10" v-if="reservation.attributes.tableNumber">
          <el-col :span="10">
            <strong>Table</strong>
          </el-col>
          <el-col :span="14" class="right">{{ reservation.attributes.tableNumber }}</el-col>
        </el-row>
      </el-card>
    </div>
    <div class="centre section" v-else>
      <strong v-if="!display.isSignedIn">
        Please
        <a>Sign In</a> to view your reservations.
      </strong>
      <strong v-else>No reservation</strong>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { listMine } from "@/api/reservation";
import logger from "@/utils/logger";

const name = "Reservations";
const log = logger(name);

export default {
  data() {
    return {
      reservations: [],

      pagination: {
        page: 1,
        size: 10
      },

      display: {
        isLoading: true,
        isSignedIn: true,
        hasNextPage: true
      }
    };
  },
  async created() {
    if (!this.token) {
      this.display.isSignedIn = false;
      this.display.isLoading = false;
      return;
    }
    await this.fetchData();
  },
  computed: {
    ...mapGetters(["token"])
  },
  methods: {
    onClickBack() {
      this.$router.back();
    },
    async fetchData() {
      this.display.isLoading = true;
      log.info(
        `Loading, page=${this.pagination.page}, size=${this.pagination.size}`
      );
      const reservations = await listMine(this.pagination);
      this._beforeRender(reservations);
      this.reservations = this.reservations.concat(reservations);
      if (reservations.length < this.pagination.size) {
        this.display.hasNextPage = false;
      }
      this.display.isLoading = false;
    },
    async loadNextPage() {
      if (!this.display.hasNextPage) {
        log.info("No further results");
        return;
      }
      ++this.pagination.page;
      log.info(`Infinite scroll loading page ${this.pagination.page}`);
      await this.fetchData();
    },

    _beforeRender(reservations) {
      reservations.forEach(reservation => {
        const createdTimeMoment = moment(reservation.createdTime);
        const reservedTimeMoment = moment(reservation.reservedTime);
        const arrivedTimeMoment = reservation.arrivedTime
          ? moment(reservation.arrivedTime)
          : null;
        reservation.display = {
          createdTime: {
            date: createdTimeMoment.format("D MMM YYYY"),
            time: createdTimeMoment.format("hh:mma")
          },
          reservedTime: {
            date: reservedTimeMoment.format("D MMM YYYY"),
            time: reservedTimeMoment.format("hh:mma")
          },
          arrivedTime: {
            date: arrivedTimeMoment && arrivedTimeMoment.format("D MMM YYYY"),
            time: arrivedTimeMoment && arrivedTimeMoment.format("hh:mma")
          },
          customer: {
            name: [reservation.customer.firstName, reservation.customer.surname]
              .filter(name => name)
              .join(" ")
          }
        };
      });
    }
  }
};
</script>

<style scoped>
.reservation-list-container {
  padding: 1rem;
}

.section {
  margin-top: 1rem;
}

.reservation-list {
  overflow: auto;
  height: 77vh;
}

.reservation-list__item {
  margin-bottom: 0.5rem;
  padding: 0 0.2rem;
}

.reservation-list__item__header {
  font-size: 0.9rem;
}

.status {
  padding: 0.1rem;
}
</style>